import React from 'react';
import PropTypes from 'prop-types';
import checkboxArrow from 'images/general/checkbox-arrow.svg';

import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 15px 0;
`;

const CheckboxInput = styled.input`
  opacity: 0;
  position: absolute;
  left: 100px;
  top: 10px;
  display: none;
  outline: 0;
`;

const Label = styled.label`
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 0;
  line-height: 26px;
  margin-bottom: 0;


  &:before, &:after {
    content: " ";
    display: inline-block;
    position: absolute;
    width: 18px;
    height: 18px;
    right: -27px;
    cursor: pointer;
    border-radius: 2px;
    top: 5px;
    background-color: transparent;
    border: 2px solid #bfbfbf;
    -webkit-transition: opacity 0.3s linear;
    transition: opacity 0.3s linear
  }

  &:after {
    opacity: ${props => props.checked ? "1" : "0"};
    background: url(${checkboxArrow}) no-repeat center;
  }
`;

const Checkbox = (props) => (
  <Wrapper >
   <CheckboxInput type={props.type} required={props.required} className={props.inputClassName} multiple={props.multiple}
    accept={props.accept} id={props.label} checked={props.checked} value={props.value} disabled={props.disabled}
    onChange={props.onChange} onFocus={props.onFocus} placeholder={props.placeholder} />
    <Label isBlack={props.black} checked={props.checked} htmlFor={props.label}>{props.label}: </Label>
  </Wrapper>
);

Checkbox.defaultProps = {
  type: 'text'
};

Checkbox.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/form/checkbox.js